import React, { Component } from "react";
import { CategoryNavigation } from "./CategoryNavigation";
import { ProductList } from "./ProductList";
import { CartSummary } from "./CartSummary";
import { ProductPageConnector } from "./ProductPageConnector";
import { PaginationControls } from "../PaginationControls";
import { Link } from "react-router-dom";
import Icon from "../favicon.ico";

const ProductPages = ProductPageConnector(PaginationControls);

export class Shop extends Component {
  handleAddToCart = (...args) => {
    this.props.addToCart(...args);
    this.props.history.push("/shop/cart");
  };

  render() {
    return (
      <div className="container-fluid shop-container">
        <div className="row navbar-div">
          <div className="text-white navbar">
            <div className="navbar-brand">
              <img src={Icon} className="logo-icon" alt="icon"></img>SPORTS
              STORE
            </div>
            <div className="navbar-search">
              <span className="navbar-search-span">
                <input className="navbar-search-input" type="search"></input>
                <button className="search-btn">Search</button>
              </span>
            </div>
            <CartSummary {...this.props} />
          </div>
        </div>
        <div className="col main-body-div">
          <div className="col-12 p-2 body">
            <div className="col-12 p-2 links">
              <h3 className="categories-header">Categories:</h3>
              <span className="divider"></span>
              <CategoryNavigation
                baseUrl="/shop/products"
                categories={this.props.categories}
              />
            </div>
            <ProductPages />
            <ProductList
              products={this.props.products}
              addToCart={this.handleAddToCart}
            />
            <ProductPages />
            <div className="footer-div">
              <Link
                className="btn btn-block btn-secondary m-2 col-3 admin-btn"
                to="/admin"
              >
                Administration
              </Link>
            </div>
          </div>
        </div>
        {/* eslint-disable-next-line */}
        <a href="#" className="to-top scroll-arrow">
          <h3 className="to-top-text">Back to top</h3>
        </a>
      </div>
    );
  }
}
